import React, { lazy, Suspense } from 'react';
import { Container } from 'components/UI';
import { LazyImage, Title } from '@landing/ui';
import { useIsSsr } from 'utils/hooks';

import * as styles from './Intro.module.scss';

const Animation = lazy(() => import('components/UI/Animation'));

export default function Intro({ title, detailsTitle, detailsDescription, logo }) {
  const isSsr = useIsSsr();
  return (
    <Container className={styles.container} background="transparent">
      <div className={styles.layout}>
        <Title tag="h1" color="white">
          {title}
        </Title>
        <div className={styles.details}>
          <div>
            <p className={styles.detailsTitle}>{detailsTitle}</p>
            <p className={styles.detailsDescription}>{detailsDescription}</p>
          </div>
          <LazyImage className={styles.logo} src={logo} />
        </div>
        {!isSsr && (
          <Suspense fallback={null}>
            <Animation preserveAspectRatio className={styles.animation} name="intro" />
          </Suspense>
        )}
      </div>
    </Container>
  );
}
